// extracted by mini-css-extract-plugin
module.exports = {"image":"cover-card_image__7n7m5","wrapper":"cover-card_wrapper__1hZrW","container":"cover-card_container__1KVG4","wide":"cover-card_wide__21GwK"};